import { RequestService } from '../../../../../common/services/RequestService';
import { DRIVE_TYPES_GET } from '../../constants';

export const getDriveTypesRequest = payload => {
  return RequestService.get(DRIVE_TYPES_GET);
};
